import { render, staticRenderFns } from "./org-profiles.vue?vue&type=template&id=710dc0f2&scoped=true&"
import script from "./org-profiles.vue?vue&type=script&lang=js&"
export * from "./org-profiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710dc0f2",
  null
  
)

export default component.exports